import { combineReducers, configureStore } from '@reduxjs/toolkit';
import type { PreloadedState } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import commonReducer from './pages/store/store';
import clientsReducer from './pages/clients/store';
import credentialReducer from './pages/credentials/store';
import authReducer from './layout/login/auth';
import profileReducer from './pages/profile/store';
import balanceReducer from './modules/balance/store';
import rateReducer from './modules/rate/store';
import payablesReducer from './pages/payables/store';
import paymentsReducer from './pages/payables/store/payments';
import combinedBalanceReducer from './modules/combined_balance/store';
import walletsReducer from './modules/wallets/store';
import whiteLabelSlice from './layout/login/store/whiteLabel.slice';
import authMiddleware from './services/auth/authMiddleware';

const rootReducer = combineReducers({
  auth: authReducer,
  balance: balanceReducer,
  profile: profileReducer,
  common: commonReducer,
  clients: clientsReducer,
  rate: rateReducer,
  payables: payablesReducer,
  payments: paymentsReducer,
  wallets: walletsReducer,
  combinedBalance: combinedBalanceReducer,
  credentials: credentialReducer,
  whiteLabel: whiteLabelSlice,
});

export const store = (preloadedState?: PreloadedState<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(authMiddleware),
  });

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof store>;
export type AppDispatch = AppStore['dispatch'];
export const useAppDispatch: () => AppDispatch = useDispatch;
